import { useEffect } from "react";
import { scrollToTop } from "../../../store/actions/app";
import Styles from "./Wizard.module.css";

function PageWrapper({ legendInfo, required, children }) {
  useEffect(() => {
    scrollToTop("#scrollable");
  }, []);

  return (
    <fieldset className={`${Styles.anonFieldset} ${Styles.fadeIn}`}>
      <legend
        className={
          required ? `required-field ${Styles.anonLegend}` : Styles.anonLegend
        }
      >
        {legendInfo}
      </legend>
      <hr className={Styles.anonHR} />
      <div className={Styles.pageContainer}>
        <div className={Styles.innerWrapper}>{children}</div>
      </div>
    </fieldset>
  );
}

export default PageWrapper;
